import { extendTailwindMerge } from 'tailwind-merge'

export const twMerge = extendTailwindMerge({
  cacheSize: 500,
  prefix: 'tw-',
  theme: {
    colors: [
      'ui-red', 'ui-black', 'ui-title-black', 'ui-blue',
      'ui-button-blue', 'ui-light-grey', 'ui-white'
    ],
    borderRadius: [
      'dropzone', 'footer'
    ]
  }
})
